/** First vacant-clean room from RoomAssignListing. */
export function pickFirstVcRoom(listing: any[] | null | undefined) {
  const match = listing?.find((r: any) => r?.RoomAssignmentStatus?.Code === 'VC');
  return match ? { ...match, IsSelected: true } : null;
}
